import axios from '@/api/axios'

const createTrainingTemplate = (template) => {
  return axios.post('/trainingsTemplate', template)
}

const getTrainingsTemplate = () => {
  return axios.get('/trainingsTemplate')
}

const getTrainingsTemplateBySchoolId = (params) => {
  return axios
    .get(`/trainingsTemplate`, {params})
    .then((response) => response.data)
}

const getTrainingTemplate = (id) => {
  return axios.get(`/trainingsTemplate/${id}`)
}

const updateTrainingTemplate = (id, template) => {
  return axios.put(`/trainingsTemplate/${id}`, template)
}

const deleteTrainingTemplate = (id) => {
  return axios.delete(`/trainingsTemplate/${id}`)
}

export default {
  createTrainingTemplate,
  getTrainingsTemplate,
  getTrainingTemplate,
  updateTrainingTemplate,
  deleteTrainingTemplate,
  getTrainingsTemplateBySchoolId,
}
